// Strictly for Dev
const SETTINGS = {
    COOKIE_DOMAIN: '.noon.partners',

    DEFAULT_COUNTRY_CODE: 'AE',
    DEFAULT_ISD_CODE: '+971',
    PHONE_NUMBER: '800-3-6006',
    PHONE_NUMBER_KSA: '800-1160211',
    CONTACT_NUMBER: '(971) 800-3-6006',

    ISD_CODE_KSA: '+966',
    CHECKOUT_ASSISTANCE_KSA: '800-1160210',
    CONTACT_NUMBER_KSA: '(966) 800 116 0210',

    CONTACT_EMAIL: 'seller@noon.com',
    APPSTORE_LINK: 'https://www.apple.com/ios/app-store/',
    GOOGLEPLAY_LINK: 'https://play.google.com/store',
    EXPIRE_LOCALSTORAGE: 300000, // 5 * 60 * 1000, 5 minutes,

    DEFAULT_IMG_WIDTH: '600',
    DEFAULT_IMG_HEIGHT: '819',
    SAR_CONVERSION_RATE: 1.021,
    SENTRY_URL: "https://bb4f2b00d5c04708a0f03944ee6e8d8b@sentry.io/275986",
    NIS_LINK: `https://storage.googleapis.com/slapi-production/nis/New%20Templates%20-%20August'18.zip`,

    BASE_IMG_URL: 'https://k.nooncdn.com/',
    LOGIN_URL: 'https://login.noon.partners',
    HOME_URL: 'https://www.noon.com',
    PARTNER_URL: 'https://verify.noon.com',
    NOON_STORE_NAMES: ['noon', 'noon Retail'],

    SUPPORT_EN: 'https://help.noon.partners/hc/en-us',
    SUPPORT_AR: 'https://help.noon.partners/hc/ar',

    ALGOLIA_APP_ID: 'BHFNGI9C92',
    ALGOLIA_APP_KEY: 'f08d06af2065f9318f2e50d610bb6bd9'
};

export default SETTINGS;



// WEBPACK FOOTER //
// ./src/config/index.js